import { withChartLayout } from 'components/common';
import MobilityPhysicalTherapy from 'components/features/chart/admission-history/mobility-physical-therapy/MobilityPhysicalTherapy';

const MobilityPhysicalTherapyPage = withChartLayout('Mobility and Physical Therapy Screen')(MobilityPhysicalTherapy);
export default MobilityPhysicalTherapyPage;
